/**
 * KAN-925: следит, что аккаунт этой вкладки не удалён в другой вкладке
 * (логика в useTabAccountWatch). Ничего не рисует.
 */
import { useTabAccountWatch } from '@/hooks/useAccounts';

export function TabAccountWatch(): null {
  useTabAccountWatch();
  return null;
}
